module.exports = __webpack_public_path__ + "static/img/icon_whatsapp.99cb005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_whatsapp.png
// module id = fdWK
// module chunks = 0